module.exports = __webpack_public_path__ + "static/media/rewards_basic.18d10a54.png";